import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from "@angular/router";
import { Title } from '@angular/platform-browser';
import { NodeService } from '../../shared/services/nodeservice.service';
import { InvestmentDetails } from '../../shared/services/investment-details';
import { PolicyDocuments } from '../../shared/services/policy-documents';
import { Note } from '../../shared/services/note';
import { AppRegDetails } from '../../shared/services/appreg-details';
import { AuditHistory } from '../../shared/services/audit-history';
import { FormControl, FormBuilder, FormGroup } from "@angular/forms";

@Component({
    selector: 'app-investor-details',
    templateUrl: './investor-details.component.html'
})
export class InvestorDetailsComponent implements OnInit {

    loading: boolean;
    files1: InvestmentDetails[];
    files2: PolicyDocuments[];
    files3: Note[];
    files4: AuditHistory[];
    files5: AppRegDetails[];

    cols: any[];
    uploadForm: FormGroup;
    notesForm: FormGroup;

    showEmailApplicantDialog: boolean = false;
    isNotSent: boolean = true;
    isSent: boolean = false;

    positionLeft: any;

    constructor(private title: Title, private router: Router, private nodeService: NodeService, private fb: FormBuilder) {
        this.title.setTitle('Investor Details | XYZ Corp. Verification Workspace');
    }

    ngOnInit() {
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0)
        });

        this.loading = true;
        this.nodeService.getInvestmentDetails().then(files => this.files1 = files);
        this.nodeService.getPolicyDocuments().then(files => this.files2 = files);
        this.nodeService.getNotes().then(files => this.files3 = files);
        this.nodeService.getAuditHistory().then(files => this.files4 = files);
        this.nodeService.getAppRegDetails().then(files => this.files5 = files);

        this.uploadForm = this.fb.group({
            'fileType': new FormControl(null),
        });

        this.notesForm = this.fb.group({
            'noteText': new FormControl(''),
        });

    }

    showSentConfirmation() {
        setTimeout(() => {
            this.showEmailApplicantDialog = true;
        }, 0);
        this.isNotSent = false;
        this.isSent = true;
    }

    setStatusClass(applicationStatus) {
        switch (applicationStatus) {
            case 'Complete':
                return 'green';
            case 'New Application':
                return 'grey';
            case 'Pending Payment':
                return 'blue';
            case 'Rejected':
                return 'red';
            case 'Pending Finance':
                return 'purple';
        }
    }

    onNavigateBack() {
        this.router.navigate(['investors']);
    }

}
